<img
  class="img-background"
  src="../../../../../assets/img/background-pages.jpg"
  alt="Background"
/>

<header class="bg-black p-0 text-center z-2 position-fixed w-100 top-0">
  <img src="assets/img/logo-tix.png" width="60px" alt="" />
</header>

<app-not-available
  *ngIf="invalidOrder; else content"
  [message]="'Opss!... Esta orden no existe'"
></app-not-available>

<ng-template #content class="relative">
  <order-detail-headband
    [loading]="loadingOrderDetail"
    [order]="order ?? null"
  ></order-detail-headband>

  <app-order-skeleton *ngIf="loadingOrderDetail"></app-order-skeleton>

  <div
    *ngIf="!loadingOrderDetail"
    class="container-fluid my-3 d-flex flex-column"
    style="max-width: 80rem"
  >
    <!-- Event Info - Order 1 on mobile, Order 4 on desktop -->
    <div class="order-1 order-lg-4 mb-4 mt-3" *ngIf="order.tickets_comments">
      <div
        class="card card-solid card-bg-transparent p-4 container-fluid"
        style="border-radius: 24px; max-width: 78.5rem"
      >
        <div class="d-flex align-items-start gap-3 mb-4">
          <div
            class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
            style="
              width: 40px;
              height: 40px;
              background-color: #dbeafe;
              color: #2563eb;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 16v-4"></path>
              <path d="M12 8h.01"></path>
            </svg>
          </div>

          <div>
            <h3 class="h5 fw-bold text-dark mb-1">Información del Evento</h3>
            <p class="small text-muted mb-0">Comentarios</p>
          </div>
        </div>

        <div class="d-flex flex-column gap-4">
          <!-- <div>
            <h4 class="h6 fw-bold text-dark mb-2">Qué Esperar</h4>
            <p class="mb-0" style="color: #364153">
              Este evento promete ser una experiencia inolvidable. Disfruta de
              una noche llena de entretenimiento, música en vivo y un ambiente
              espectacular. Asegúrate de llegar con tiempo suficiente para
              disfrutar de todas las actividades programadas.
            </p>
          </div> -->

          <div>
            <p class="mb-0 text-dark">
              {{ order.tickets_comment }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Row container - Order 2-4 on mobile, Order 1-3 on desktop -->
    <div class="row g-4 order-2 order-lg-1">
      <!-- Invoice - Order 4 on mobile, Order 1 on desktop (left column) -->
      <div class="col-12 col-lg-6 order-4 order-lg-1">
        <div class="card card-solid bg-white rounded-tix h-fit">
          <div class="card-body p-4 d-flex flex-column gap-3">
            <div class="d-flex align-items-center gap-3">
              <div class="tix-logo">
                <img src="assets/img/logo-tix.png" alt="" width="54" />
              </div>
              <div>
                <h3 class="h6 mb-0 text-dark">
                  TIX-{{ order?.id ?? '128334' }}
                </h3>
                <p class="small text-muted mb-0">
                  {{ totalTicketsCount }} tickets
                </p>
              </div>
            </div>

            <div class="">
              <ng-container
                *ngFor="let ticketType of parsedTicketsData; let i = index"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-fill">
                    <p class="mb-1 text-dark">
                      {{ ticketType.ticketTypeName
                      }}<span class="text-muted small">
                        x {{ ticketType.qty }}</span
                      >
                    </p>
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <span class="text-muted small">{{
                        order?.free_event
                          ? ''
                          : 'RD$' + (ticketType.price | number)
                      }}</span>
                    </div>
                    <div class="d-flex align-items-center" *ngIf="ticketType.isSeat">
                      <span class="text-black small"
                        >Asientos: {{ ticketType.ticketsLabel.join(', ') }}</span
                      >
                    </div>
                  </div>
                  <p class="mb-0 text-dark">
                    RD${{ ticketType.qty * ticketType.price | number }}
                  </p>
                </div>
                <hr class="my-3" *ngIf="i < parsedTicketsData.length - 1" />
              </ng-container>
            </div>

            <hr class="my-4" />

            <div class="d-flex flex-column gap-2">
              <div class="d-flex justify-content-between">
                <span class="text-muted">Subtotal</span>
                <span class="text-dark">RD${{ order?.subTotal | number }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted">Cargo por Servicio</span>
                <span class="text-dark"
                  >RD${{ order?.serviceFee | number }}</span
                >
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted">Seguro</span>
                <span class="text-dark"
                  >RD${{ order?.insuranceFee | number }}</span
                >
              </div>
              <div class="d-flex justify-content-between" *ngIf="hasCoupons()">
                <span style="color: #28a745">
                  {{ getCouponsCount() > 1 ? 'Códigos' : 'Código' }} de
                  Descuento ({{ allCouponsNames }})
                </span>
                <span style="color: #28a745">
                  <span class="text-nowrap">-RD$</span
                  >{{ order?.discounted | number }}
                </span>
              </div>

              <hr class="my-2" />

              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold text-dark">Total Pagado</span>
                <span class="fw-bold text-dark"
                  >RD${{ order?.totalToPay | number }}</span
                >
              </div>
            </div>

            <div class="bg-light rounded-3 p-3 d-flex flex-column gap-2 mt-4">
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted small">Nombre</span>
                <span class="text-dark small">{{ order?.buyerName }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted small">Email</span>
                <span class="text-dark small">{{ order?.buyerEmail }}</span>
              </div>
              <ng-container *ngIf="order?.totalToPay && order!.totalToPay > 0">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted small">Método de Pago</span>
                  <div class="d-flex align-items-center gap-2">
                    <img
                      [src]="cardLogo"
                      alt="card type"
                      style="width: 36px; height: 22px; object-fit: contain"
                    />
                    <span class="text-dark small">{{
                      extractCardSuffix(order?.creditCard ?? '')
                    }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted small">Autorización</span>
                  <span class="text-dark small">{{
                    order?.authorization
                  }}</span>
                </div>
              </ng-container>

              <hr class="my-2" />

              <div class="text-center">
                <span
                  class="text-dark small"
                  style="text-transform: capitalize"
                  >{{ order?.createdAt | customDate }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right column - Tickets and Comments - Order 2-3 on mobile, Order 2 on desktop -->
      <div class="col-12 col-lg-6 order-2 order-lg-2 d-flex flex-column gap-4">
        <!-- Tickets - Order 2 on mobile -->
        <div class="order-2 order-lg-1">
          <order-detail-tickets [order]="order"></order-detail-tickets>
        </div>

        <!-- Comments - Order 3 on mobile -->
        <div class="order-3 order-lg-2">
          <div
            *ngIf="getComments().length > 0"
            class="card card-solid rounded-tix small card-bg-transparent"
          >
            <div
              class="card-header border-bottom rounded-tix py-3 d-flex align-items-center gap-3 bg-transparent"
              style="
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
              "
            >
              <div
                class="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                style="
                  width: 40px;
                  height: 40px;
                  background-color: #dbeafe;
                  color: #2563eb;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
              </div>

              <div>
                <h5 class="text-dark mb-0">Información adicional</h5>
              </div>
            </div>

            <ul
              class="list-group rounded-0 border-0 rounded-tix text-dark bg-transparent"
            >
              <li
                class="list-group-item border-0 border-bottom text-dark d-flex justify-content-between align-items-center py-3 bg-transparent"
                *ngFor="let comment of getComments()"
              >
                <div class="">{{ comment }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />
</ng-template>
<core-loading [visible]="isLoading"></core-loading>

<!-- Modal dialog to display all tickets -->
<div
  class="modal fade"
  id="all_tickets"
  tabindex="-1"
  aria-labelledby="all_tickets_label"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-xl modal-dialog-centered modal-fullscreen modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header d-print-none">
        <h1
          class="modal-title fs-5 d-flex align-items-center"
          id="all_tickets_label"
        >
          <span
            class="material-symbols-outlined p-0 m-0"
            style="font-size: 24px"
            >qr_code_scanner</span
          >
          Tickets
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body overflow-scroll">
        <app-order-tickets
          [pageTickets]="pageTickets"
          [page]="page"
          [totalPages]="totalPages"
          (loading)="handleLoad()"
          [order]="order"
        ></app-order-tickets>
      </div>
      <div
        class="modal-footer justify-content-between align-items-center d-flex"
      >
        <div class="w-25">
          {{ pageTickets.length }}/{{ order?.tickets?.length }} tickets
        </div>
        <nav class="">
          <ul class="pagination m-0">
            <li class="page-item">
              <button
                (click)="prevPage()"
                [disabled]="page <= 1"
                class="page-link"
                aria-label="Previous"
              >
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>
            <li class="page-item">
              <div class="page-link">{{ page }}/{{ totalPages }}</div>
            </li>
            <li class="page-item">
              <button
                (click)="nextPage()"
                [disabled]="page >= totalPages"
                class="page-link"
                aria-label="Next"
              >
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
        <div class="d-flex justify-content-end">
          <button
            [disabled]="isLoading"
            (click)="downloadTickets()"
            class="d-block d-md-none bg-black btn-lg btn-dark btn d-flex align-items-center gap-2 justify-content-center"
          >
            <span class="material-symbols-outlined">picture_as_pdf</span>
            <span class="d-none d-md-block">Descargar PDF</span>
          </button>

          <div class="dropdown d-none d-md-block">
            <button
              class="btn btn-dark dropdown-toggle d-flex align-items-center gap-2"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="material-symbols-outlined">download</span>
              Descargar
            </button>

            <ul class="dropdown-menu shadow">
              <li>
                <button [disabled]="isLoading" (click)="downloadTickets(false)">
                  <span class="material-symbols-outlined">picture_as_pdf</span>
                  <span>Descargar PDF</span>
                </button>
              </li>
              <li>
                <button [disabled]="isLoading" (click)="downloadTickets(true)">
                  <span class="material-symbols-outlined">print</span>
                  <span>Descargar para imprimir</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
